// import React, { useState } from "react";
// import { labelUtils } from "../Util";
// import FormGroupWrapper from "./FormGroupWrapper";
// import store, { rootReducer } from "../../../../store";
// import { setRendererFormState } from "../../../../slices/common/reducer";

// const File = ({
//   arrEle,
//   newElfromJSON,
//   fieldEle,
//   formState,
//   displayLabelKey,
//   databaseKey,
//   showRequired = true,
// }) => {
//   let key = databaseKey ? databaseKey : displayLabelKey;
//   const [error, setError] = useState("");

//   return (
//     <FormGroupWrapper
//       arrEle={arrEle}
//       newElfromJSON={newElfromJSON}
//       fieldEle={fieldEle}
//     >
//       <div
//         className="form-builder-element"
//         style={{ width: labelUtils.getElementWidth(fieldEle) }}
//       >
//         <div className="file-wrapper-container">
//           <div className="custom-file" id={`${newElfromJSON}_custom-file`}>
//             <input
//               id={newElfromJSON}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") {
//                   e.preventDefault();
//                 }
//               }}
//               type="file"
//               className={`custom-file-input form-control ${
//                 error ? "is-invalid" : ""
//               }`}
//               placeholder={fieldEle?.["display-placeholder"]}
//               required={
//                 showRequired ? (fieldEle?.["display-required"] === 1 && !formState[`${key}_name`] ? true : false) : false
//               }
//               disabled={fieldEle?.["display-disabled"] === 1}
//               accept={fieldEle?.["validation-filepattern"]}
//               name={key}
//               onChange={(e) => {
//                 const file = e.target.files[0];
//                 if (file) {
//                   const fileName = file.name;
//                   const maxSize = fieldEle?.["validation-filesize"];
//                   let maxSizeParts = [];
//                   let maxSizeInBytes = 0;

//                   if (maxSize) {
//                     maxSizeParts = maxSize.split(" * ");
//                     if (maxSizeParts.length === 3) {
//                       maxSizeInBytes =
//                         parseInt(maxSizeParts[0], 10) *
//                         parseInt(maxSizeParts[1], 10) *
//                         parseInt(maxSizeParts[2], 10);
//                     }
//                   }

//                   if (maxSizeInBytes > 0 && file.size > maxSizeInBytes) {
//                     setError(
//                       `File size exceeds the limit of ${maxSizeParts[2] || "unknown"} MB`
//                     );

//                     e.target.value = null;
//                     store.dispatch(setRendererFormState({ key, value: null }));
//                     store.dispatch(
//                       setRendererFormState({ key: `${key}_name`, value: "" })
//                     );
//                     return;
//                   }
//                   setError("");
//                   rootReducer.dispatch(setRendererFormState({ key, value: file }));
//                   rootReducer.dispatch(
//                     setRendererFormState({
//                       key: `${key}_name`,
//                       value: fileName,
//                     })
//                   );
//                 } else {
//                   setError("This field is required.");
//                   rootReducer.dispatch(setRendererFormState({ key, value: null }));
//                   rootReducer.dispatch(
//                     setRendererFormState({ key: `${key}_name`, value: "" })
//                   );
//                 }
//               }}
//             />

//             <label className="custom-file-label">
//               {formState[`${key}_name`] || "Choose File"}
//             </label>

//             {/* Show error message */}
//             {error && <div className="invalid-feedback">{error}</div>}

//             {fieldEle?.["display-description"] && (
//               <div className="form-text text-muted formElementDesc">
//                 {fieldEle?.["display-description"]}
//               </div>
//             )}
//             <div className="file-type-container">
//               {fieldEle?.["display-description"] ||
//               fieldEle?.["validation-filepattern"] ||
//               fieldEle?.["validation-filesize"] ? (
//                 <>
//                   {fieldEle?.["display-description"] ? (
//                     <span>{fieldEle["display-description"]}</span>
//                   ) : (
//                     <>
//                       {fieldEle?.["validation-filepattern"] && (
//                         <span>
//                           File Type:{" "}
//                           {fieldEle["validation-filepattern"]
//                             .replace(".", "")
//                             .toUpperCase()}
//                         </span>
//                       )}
//                       {fieldEle?.["validation-filesize"] && (
//                         <span
//                           className="file-size"
//                           style={{ marginLeft: "auto" }}
//                         >
//                           Max File Size:{" "}
//                           {fieldEle["validation-filesize"]
//                             .split(" * ")
//                             .reduce((acc, val) => acc * parseInt(val), 1) /
//                             (1024 * 1024)}{" "}
//                           MB
//                         </span>
//                       )}
//                     </>
//                   )}
//                 </>
//               ) : null}
//             </div>
//           </div>
//         </div>
//       </div>
//     </FormGroupWrapper>
//   );
// };

// export default File;

// import React, { useEffect, useState } from "react";
// import { labelUtils } from "../Util";
// import FormGroupWrapper from "./FormGroupWrapper";
// import store, { rootReducer } from "../../../../store";
// import { setRendererFormState } from "../../../../slices/common/reducer";
// import { Button } from "react-bootstrap";
// import {
//   CrossIcon,
//   DownloadIcon,
//   EditListIcon,
// } from "../../../../assets/images/svg/svg";

// const File = ({
//   arrEle,
//   newElfromJSON,
//   fieldEle,
//   formState,
//   displayLabelKey,
//   databaseKey,
//   showRequired = true,
// }) => {
//   let key = databaseKey || displayLabelKey;
//   const [error, setError] = useState("");
//   const [isEditing, setIsEditing] = useState(false);
//   const [valueObj, setValueObj] = useState();

//   useEffect(() => {
//     if (formState?.files) {
//       setValueObj(formState.files[key]);
//     } else {
//       setValueObj(formState[key]);
//     }
//   }, [key]);

//   return (
//     <FormGroupWrapper
//       arrEle={arrEle}
//       newElfromJSON={newElfromJSON}
//       fieldEle={fieldEle}
//     >
//       <div
//         className="form-builder-element"
//         style={{ width: labelUtils.getElementWidth(fieldEle) }}
//       >
//         <div className="file-wrapper-container">
//           <div className="custom-file" id={`${newElfromJSON}_custom-file`}>
//             {valueObj?.file_name && !isEditing ? (
//               <div className="file-info">
//                 <span className="file-name">{valueObj?.file_name}</span>
//                 {/* {mediaId && (
//                   <a
//                     href={`/api/download/${mediaId}`} // Adjust API endpoint as needed
//                     className="btn btn-link"
//                     download
//                   >
//                     Download
//                   </a>
//                 )} */}
//                 <div className="documents-button-wrapper">
//                   <Button
//                     variant="outline-secondary"
//                     // onClick={() => onDownload(file.entityid, file.filename)}
//                     // onClick={() =>
//                     //   downloadFileFromURL(file.media_url, file.filename)
//                     // }
//                     className="me-2"
//                   >
//                     <DownloadIcon />
//                   </Button>
//                   <Button
//                     variant="outline-secondary"
//                     onClick={() => setIsEditing(true)}
//                   >
//                     <EditListIcon />
//                   </Button>
//                 </div>
//               </div>
//             ) : (
//               <>
//                 <input
//                   id={newElfromJSON}
//                   onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
//                   type="file"
//                   className={`custom-file-input form-control ${
//                     error ? "is-invalid" : ""
//                   }`}
//                   placeholder={fieldEle?.["display-placeholder"]}
//                   required={
//                     showRequired
//                       ? fieldEle?.["display-required"] === 1 &&
//                         !valueObj?.file_name
//                       : false
//                   }
//                   disabled={fieldEle?.["display-disabled"] === 1}
//                   accept={fieldEle?.["validation-filepattern"]}
//                   name={key}
//                   onChange={(e) => {
//                     const file = e.target.files[0];
//                     if (file) {
//                       const maxSize = fieldEle?.["validati on-filesize"];
//                       let maxSizeInBytes = 0;

//                       if (maxSize) {
//                         const maxSizeParts = maxSize.split(" * ");
//                         if (maxSizeParts.length === 3) {
//                           maxSizeInBytes =
//                             parseInt(maxSizeParts[0], 10) *
//                             parseInt(maxSizeParts[1], 10) *
//                             parseInt(maxSizeParts[2], 10);
//                         }
//                       }

//                       if (maxSizeInBytes > 0 && file.size > maxSizeInBytes) {
//                         setError(
//                           `File size exceeds the limit of ${
//                             maxSizeParts[2] || "unknown"
//                           } MB`
//                         );
//                         e.target.value = null;
//                         store.dispatch(
//                           setRendererFormState({ key, value: null })
//                         );
//                         store.dispatch(
//                           setRendererFormState({
//                             key: `${key}`,
//                             value: "",
//                           })
//                         );
//                         return;
//                       }

//                       setError("");
//                       rootReducer.dispatch(
//                         setRendererFormState({ key, value: file })
//                       );
//                       if (!isEditing) {
//                         rootReducer.dispatch(
//                           setRendererFormState({
//                             key,
//                             value: valueObj?.media_url,
//                           })
//                         );
//                       }

//                       rootReducer.dispatch(
//                         setRendererFormState({
//                           key: `${key}_name`,
//                           value: file.name,
//                         })
//                       );
//                       setIsEditing(false);
//                     }
//                   }}
//                 />

//                 <label className="custom-file-label">
//                   {formState[`${key}_name`] || "Choose File"}
//                 </label>
//                 <span
//                   className="cancel ms-2"
//                   onClick={() => toggleEdit(fieldKey)}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <CrossIcon />
//                 </span>

//                 {error && <div className="invalid-feedback">{error}</div>}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </FormGroupWrapper>
//   );
// };

// export default File;

import React, { useEffect, useState } from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import store, { rootReducer } from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";
import { Button } from "react-bootstrap";
import {
  CrossIcon,
  DownloadIcon,
  EditListIcon,
} from "../../../../assets/images/svg/svg";
import { downloadDocument } from "../../../../Utils/CommonService";
import { useDispatch } from "react-redux";

const DocumentFile = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let key = databaseKey || displayLabelKey;
  const [error, setError] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [valueObj, setValueObj] = useState();
  const [initialValueObj, setInitialValueObj] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    if (formState && Object.keys(formState).length > 0) {
      if (formState?.files && formState.files.hasOwnProperty(key)) {
        setInitialValueObj(formState.files[key]);
        setValueObj(formState.files[key]);
      } else if (formState.hasOwnProperty(key)) {
        setInitialValueObj(formState[key]);
        setValueObj(formState[key]);
      }
    }
  }, [key, formState]);


  const handleCancelEdit = () => {
    setIsEditing(false);
    setValueObj(initialValueObj);
  };

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div className="file-wrapper-container">
          <div className="custom-file" id={`${newElfromJSON}_custom-file`}>
            {(valueObj?.file_name || formState?.[key]?.file_name) && !isEditing ? (
              <div className="file-info">
                <div className="card--img">
                  <span>{valueObj?.file_name}</span>
                </div>
                <div className="documents-button-wrapper">
                  <Button
                    className="downloadedit--button"
                    onClick={() => {
                      if (valueObj?.media_id) {
                        downloadDocument(
                          valueObj.media_id,
                          valueObj?.file_name || "downloaded-file"
                        );
                      } else {
                        console.error("No media_id available for download.");
                      }
                    }}
                  >
                    <DownloadIcon />
                  </Button>
                  <Button
                    className="downloadedit--button"
                    onClick={() => setIsEditing(true)}
                  >
                    <EditListIcon />
                  </Button>
                </div>
              </div>
            ) : (
              <div className="file-input-wrap">
                <input
                  id={newElfromJSON}
                  onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                  type="file"
                  className={`custom-file-input form-control ${error ? "is-invalid" : ""
                    }`}
                  placeholder={fieldEle?.["display-placeholder"]}
                  required={
                    showRequired
                      ? fieldEle?.["display-required"] === 1 &&
                      !formState[key] &&
                      !valueObj?.file_name &&
                      !valueObj?.name
                      : false
                  }
                  disabled={fieldEle?.["display-disabled"] === 1}
                  accept={fieldEle?.["validation-filepattern"]}
                  name={key}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const maxSize = fieldEle?.["validation-filesize"];
                      let maxSizeInBytes = 0;

                      if (maxSize) {
                        const maxSizeParts = maxSize.split(" * ");
                        if (maxSizeParts.length === 3) {
                          maxSizeInBytes =
                            parseInt(maxSizeParts[0], 10) *
                            parseInt(maxSizeParts[1], 10) *
                            parseInt(maxSizeParts[2], 10);
                        }
                      }

                      if (maxSizeInBytes > 0 && file.size > maxSizeInBytes) {
                        setError(
                          `File size exceeds the limit of ${maxSizeParts[2] || "unknown"
                          } MB`
                        );
                        e.target.value = null;
                        dispatch(setRendererFormState({ key, value: null }));
                        // dispatch(
                        //   setRendererFormState({
                        //     key: `${key}_name`,
                        //     value: "",
                        //   })
                        // );
                        return;
                      }

                      setError("");

                      dispatch(setRendererFormState({ key, value: file }));
                      setValueObj({
                        ...valueObj,
                        file_name: file.name,
                      });
                      // dispatch(
                      //   setRendererFormState({
                      //     key: `${key}_name`,
                      //     value: file.name,
                      //   })
                      // );
                      // if(initialValueObj?.file_name) {
                      //   setIsEditing(false);
                      // }
                    }
                  }}
                />

                <label
                  className={`custom-file-label ${!isEditing ? "without-cross" : ""
                    }`}
                >
                  <span className="file-name">
                    {formState[key]?.name ||
                      valueObj?.file_name ||
                      "Choose File"}
                  </span>
                </label>
                {isEditing && (
                  <span
                    className="cross--button"
                    onClick={handleCancelEdit}
                    style={{ cursor: "pointer" }}
                  >
                    <CrossIcon />
                  </span>
                )}
                {error && <div className="invalid-feedback">{error}</div>}
              </div>
            )}
            {isEditing && (
              <div className="file-type-container">
                {fieldEle?.["display-description"] ||
                  fieldEle?.["validation-filepattern"] ||
                  fieldEle?.["validation-filesize"] ? (
                  <>
                    {fieldEle?.["display-description"] ? (
                      <span>{fieldEle["display-description"]}</span>
                    ) : (
                      <>
                        {fieldEle?.["validation-filepattern"] && (
                          <span>
                            File Type:{" "}
                            {fieldEle["validation-filepattern"]
                              .replace(".", "")
                              .toUpperCase()}
                          </span>
                        )}
                        {fieldEle?.["validation-filesize"] && (
                          <span
                            className="file-size"
                            style={{ marginLeft: "auto" }}
                          >
                            Max File Size:{" "}
                            {fieldEle["validation-filesize"]
                              .split(" * ")
                              .reduce((acc, val) => acc * parseInt(val), 1) /
                              (1024 * 1024)}{" "}
                            MB
                          </span>
                        )}
                      </>
                    )}
                  </>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    </FormGroupWrapper>
  );
};

export default DocumentFile;
